import { createContext, useContext, useState, useMemo } from "react";

// === Métrica Global ===
const MetricContext = createContext();
export function MetricProvider({ children }) {
  const [globalMetric, setGlobalMetric] = useState("O2"); // "O2" | "SO2" | "Temp"

  const value = useMemo(() => ({ globalMetric, setGlobalMetric }), [globalMetric]);

  return <MetricContext.Provider value={value}>{children}</MetricContext.Provider>;
}
export function useMetric() {
  return useContext(MetricContext);
}

// === Invertir Bombas ===
const InvertContext = createContext();
export function InvertProvider({ children }) {
  const [invertBombas, setInvertBombas] = useState(false);

  const toggleInvert = () => setInvertBombas((prev) => !prev);

  const value = useMemo(() => ({ invertBombas, toggleInvert }), [invertBombas]);

  return <InvertContext.Provider value={value}>{children}</InvertContext.Provider>;
}
export function useInvert() {
  return useContext(InvertContext);
}

// === Wrapper combinado para no cambiar mucho el árbol ===
export function ModuleControlsProvider({ children }) {
  return (
    <MetricProvider>
      <InvertProvider>{children}</InvertProvider>
    </MetricProvider>
  );
}

// import { createContext, useContext, useState } from "react";

// const ModuleControlsContext = createContext();

// export function ModuleControlsProvider({ children }) {
//   const [globalMetric, setGlobalMetric] = useState("O2"); // "O2" | "SO2" | "Temp"
//   const [invertBombas, setInvertBombas] = useState(false);

//   const toggleInvert = () => setInvertBombas((prev) => !prev);

//   return (
//     <ModuleControlsContext.Provider
//       value={{ globalMetric, setGlobalMetric, invertBombas, toggleInvert }}
//     >
//       {children}
//     </ModuleControlsContext.Provider>
//   );
// }

// export function useModuleControls() {
//   return useContext(ModuleControlsContext);
// }
